export const OptionOrderInput = $hasDep('ui-addon-draggable', '3') // eslint-disable-next-line @typescript-eslint/no-var-requires
? require('./OptionOrderInput.V3').default // eslint-disable-next-line @typescript-eslint/no-var-requires
: require('./OptionOrderInput.V2').default;

/**
 * foundations-components compatible drag list handle
 */
export const DragListHandle = $hasDep('ui-addon-draggable', '3') // eslint-disable-next-line @typescript-eslint/no-var-requires
? require('foundations-components/transitional/components/DragHandle').DragHandle : $hasDep('ui-addon-draggable', '2') ?
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('ui-addon-draggable/draggable/DragListHandle').default :
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('ui-addon-draggable/draggable/DragListHandle').DragListHandle;